import httpInterceptor from './HttpInterceptor';

export const InterceptorConfig = {
    init: () => {
        httpInterceptor.init();
        return InterceptorConfig;
    },

    destroy: () => {
        httpInterceptor.destroy();
        return InterceptorConfig;
    }
};

export default InterceptorConfig;